import { render, staticRenderFns } from "./dhl_nice.vue?vue&type=template&id=bdf2fcfc&scoped=true&"
import script from "./dhl_nice.vue?vue&type=script&lang=js&"
export * from "./dhl_nice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf2fcfc",
  null
  
)

export default component.exports